import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
interface CountdownTimerProps {
  hours?: number;
  minutes?: number;
  seconds?: number;
  className?: string;
}
export function CountdownTimer({
  hours = 1,
  minutes = 46,
  seconds = 46,
  className = ''
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours,
    minutes,
    seconds
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let newSeconds = prev.seconds - 1;
        let newMinutes = prev.minutes;
        let newHours = prev.hours;
        if (newSeconds < 0) {
          newSeconds = 59;
          newMinutes -= 1;
        }
        if (newMinutes < 0) {
          newMinutes = 59;
          newHours -= 1;
        }
        if (newHours < 0) {
          // Reset timer when it reaches 0
          return {
            hours,
            minutes,
            seconds
          };
        }
        return {
          hours: newHours,
          minutes: newMinutes,
          seconds: newSeconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [hours, minutes, seconds]);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <div className={`inline-flex items-center gap-2 bg-[#FEF3C7] border border-[#F59E0B] rounded-lg px-4 py-2 ${className}`} data-id="element-23">
      <Clock className="w-5 h-5 text-[#D97706]" data-id="element-24" />
      <span className="text-sm font-bold text-[#D97706] uppercase tracking-wide" data-id="element-25">
        Oferta termina en:
      </span>
      <div className="flex items-center gap-1 font-mono font-bold text-[#B45309] text-lg" data-id="element-26">
        <span className="bg-white px-2 py-0.5 rounded shadow-sm" data-id="element-27">
          {formatNumber(timeLeft.hours)}
        </span>
        <span data-id="element-28">:</span>
        <span className="bg-white px-2 py-0.5 rounded shadow-sm" data-id="element-29">
          {formatNumber(timeLeft.minutes)}
        </span>
        <span data-id="element-30">:</span>
        <span className="bg-white px-2 py-0.5 rounded shadow-sm" data-id="element-31">
          {formatNumber(timeLeft.seconds)}
        </span>
      </div>
    </div>;
}